// src/services/limitsService.js

import axios from "axios";

const API_BASE_URL =
  `${process.env.REACT_APP_API_URL}/api` ||
  "https://api-admin.fintech-aigle.com/api";

// Créer une instance axios avec les headers par défaut
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Intercepteur pour ajouter le token à chaque requête
apiClient.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("adminToken") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const limitsService = {
  /**
   * Récupère toutes les organisations
   */
  getAllOrganisations: async () => {
    try {
      const response = await apiClient.get("/organisations/");
      return response.data;
    } catch (error) {
      console.error("Erreur récupération organisations:", error);
      throw error;
    }
  },

  /**
   * Récupère les statistiques globales des limites
   */
  getGlobalStats: async () => {
    try {
      const response = await apiClient.get("/admin/organisations/limits/stats");
      return response.data;
    } catch (error) {
      console.error("Erreur récupération stats:", error);
      throw error;
    }
  },

  /**
   * Récupère toutes les limites des organisations
   */
  getAllLimits: async () => {
    try {
      const response = await apiClient.get("/admin/organisations/limits");
      return response.data;
    } catch (error) {
      console.error("Erreur récupération limites:", error);
      throw error;
    }
  },

  /**
   * Récupère les limites d'une organisation spécifique
   */
  getOrganisationLimits: async (organisationId) => {
    try {
      const response = await apiClient.get(
        `/admin/organisations/${organisationId}/limits`,
      );
      return response.data;
    } catch (error) {
      console.error("Erreur récupération limite organisation:", error);
      throw error;
    }
  },

  /**
   * Met à jour les limites d'une organisation
   */
  updateOrganisationLimits: async (organisationId, data) => {
    try {
      const response = await apiClient.put(
        `/admin/organisations/${organisationId}/update-limits`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error("Erreur mise à jour limites:", error);
      throw error;
    }
  },

  /**
   * Réinitialise les compteurs d'une organisation
   */
  resetCounters: async (organisationId, type) => {
    try {
      const response = await apiClient.post(
        `/admin/organisations/${organisationId}/limits/reset`,
        { type },
      );
      return response.data;
    } catch (error) {
      console.error("Erreur réinitialisation compteurs:", error);
      throw error;
    }
  },
};

export default limitsService;
